import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1336c681"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-left":"auto"} }
const _hoisted_2 = { class: "form-td" }
const _hoisted_3 = { class: "text-description" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 正しいメールアドレスの形式で入力してください。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTextarea = _resolveComponent("AppTextarea")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_TextAlert = _resolveComponent("TextAlert")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("th", null, [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            style: _normalizeStyle([{"padding":"0"}, { width: _ctx.props.width }]),
            "aria-live": "polite"
          }, _toDisplayString(_ctx.props.name), 5),
          (_ctx.props.required)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["label required", `required-${_ctx.props.id}`]),
                "aria-live": "polite"
              }, "必須", 2))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_2, [
      (_ctx.props.textarea)
        ? (_openBlock(), _createBlock(_component_AppTextarea, {
            key: 0,
            modelValue: _ctx.state,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state) = $event)),
            label: _ctx.props.name,
            class: _normalizeClass(`textarea-${_ctx.props.id}`),
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.blurFlag = true))
          }, null, 8, ["modelValue", "label", "class"]))
        : (_openBlock(), _createBlock(_component_AppInput, {
            key: 1,
            modelValue: _ctx.state,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state) = $event)),
            label: _ctx.props.name,
            type: _ctx.props.type,
            inputId: `input-${_ctx.props.id}`,
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.blurFlag = true))
          }, null, 8, ["modelValue", "label", "type", "inputId"])),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.props.description), 1),
      (_ctx.props.required && _ctx.state === '' && (_ctx.blurFlag || _ctx.props.requiredCheck))
        ? (_openBlock(), _createBlock(_component_TextAlert, {
            key: 2,
            class: _normalizeClass(`errMsg-${_ctx.props.id}`)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.props.name) + "を入力してください。 ", 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (_ctx.state && _ctx.emailCheck && (_ctx.blurFlag || _ctx.props.requiredCheck))
        ? (_openBlock(), _createBlock(_component_TextAlert, {
            key: 3,
            class: _normalizeClass('errMsg-emailCheck')
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}